import { Container } from "@mui/material";
import React from "react";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const LockerMenu = (props) => {
  const handleClick = () => {
    const textToCopy = '0x64d3799fe6E5e833996752c252A141F2Cfe7EaA9';
    navigator.clipboard.writeText(textToCopy);
    toast.success('0x64d3799fe6E5e833996752c252A141F2Cfe7EaA9');
  };

  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass

    {
      title: "Copy Contract",
      onClick: handleClick,
    },
  ];
  return (
    <Container maxWidth="xl"
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in"
      data-aos-delay="400"
      data-aos-duration="400"
      data-aos-offset="0">
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
      
      <ToastContainer />
    </Container>
  );
};

export default LockerMenu;
